/* eslint-disable no-unused-vars */
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Avatar, Button, IconButton, Typography, Grid } from '@mui/material';
import { ReactComponent as Alert } from 'assets/icons/alert.svg';
import { ReactComponent as Call } from 'assets/icons/call.svg';
import { ReactComponent as Message } from 'assets/icons/Chat.svg';
import { ReactComponent as Paper } from 'assets/icons/Paper.svg';
import { ReactComponent as ProfileRed } from 'assets/icons/profile_skel.svg';
import { useContext, useState } from 'react';
import CircularProgressBar from 'component/CircularProgressBar/CircularProgressBar';
import LinearProgressBar from 'component/LineProgressBar/LineProgressBar';
import {
  displayFlex,
  displayFlexColumn,
  fontsize10,
  fontsize12,
  fontsize14,
  poppins400,
  poppins500,
} from 'theme/common.style';
import ContactPopOver from './ContactPopOver';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { datacontext } from 'modules/AppLayout/AppLayout';

export const Calldownarrow = () => {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.44887 7.77981C3.40779 7.73979 3.23213 7.58867 3.08763 7.4479C2.17883 6.6226 0.691333 4.46966 0.237292 3.34281C0.164333 3.17168 0.00991667 2.73902 0 2.50785C0 2.28635 0.051 2.07519 0.154417 1.8737C0.298917 1.62252 0.526292 1.42103 0.79475 1.31062C0.981042 1.23955 1.5385 1.12914 1.54842 1.12914C2.15829 1.01873 3.14925 0.958008 4.24433 0.958008C5.28771 0.958008 6.23829 1.01873 6.85737 1.10913C6.86729 1.11948 7.56004 1.22989 7.79733 1.35064C8.23083 1.57215 8.5 2.00481 8.5 2.46783V2.50785C8.48938 2.8094 8.22021 3.44356 8.21029 3.44356C7.75554 4.50968 6.341 6.61294 5.40104 7.45825C5.40104 7.45825 5.1595 7.69632 5.00863 7.79983C4.79187 7.9613 4.52342 8.04134 4.25496 8.04134C3.95533 8.04134 3.67625 7.95095 3.44887 7.77981Z"
        fill="#666666"
      />
    </svg>
  );
};

export const ValueForming = () => (
  <Typography sx={{ ...poppins400, ...fontsize14, textAlign: 'left' }}>
    FHB
  </Typography>
);

export const Contact = ({ row, directcomm }) => {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const history = useHistory();
  const { setShowMessage, setMessagedata } = useContext(datacontext);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setDialogOpen(true);
  };

  const handleMouseLeave = () => {
    setTimeout(() => {
      setIsHovered(false);
    }, 1500);
  };
  return (
    <Typography
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
      }}
    >
      <Avatar
        variant="rounded"
        style={{
          borderRadius: '5px',
          width: '30px',
          height: '30px',
          border: '1px solid rgba(224, 224, 224, 1)',
          background: 'white',
          cursor: 'pointer',
        }}
        sx={{ marginRight: 1 }}
        onClick={() => {
          directcomm(row?.user?.userId);
        }}
      >
        <Message height={16} width={16} />
      </Avatar>
      &nbsp;
      <Avatar
        variant="rounded"
        style={{
          borderRadius: '5px',
          width: '30px',
          height: '30px',
          border: '1px solid rgba(224, 224, 224, 1)',
          background: 'white',
          cursor: 'pointer',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={handleMouseLeave}
        onClick={() => {
          // localStorage.setItem('dialId', row?.userEmail);
          // setShowMessage(true);
          // setMessagedata({ incomingcall: true });
          return window.open(`tel:` + row?.userMobile);
        }}
      >
        <Call height={16} width={16} />
      </Avatar>
      {/* &nbsp;&nbsp;
      <Grid
        sx={{ alignItems: 'center', marginTop: '3px', cursor: 'pointer' }}
        onClick={handleClick}
      >
        {isHovered && (
          <Calldownarrow
            style={{ position: 'absolute', top: '-10px', left: '50%' }}
          />
        )}
      </Grid>
      <ContactPopOver
        name={row?.user?.userName}
        surname={row?.user?.userSurName}
        emailid={row?.userEmail}
        mobilenum={row?.userMobile}
        isDialogOpen={isDialogOpen}
        setDialogOpen={setDialogOpen}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
      /> */}
    </Typography>
  );
};

export const ProgressData = (per) => (
  <Typography>
    <LinearProgressBar value={10} />
  </Typography>
);

export const OfferContainer = ({ color, row }) => (
  <Typography sx={displayFlexColumn}>
    <Typography sx={{ ...poppins400, ...fontsize14 }}>
      $ {row?.offerPrice}
    </Typography>
    <Typography
      sx={{ ...poppins500, ...fontsize10 }}
      style={{
        background: color || 'green',
        boder: '1px solid red',
        borderRadius: '5px',
        color: 'white',
        padding: '4px 8px',
      }}
    >
      {{ ...color } === 'red' ? 'Conditional' : ' Unconditional'}
    </Typography>
  </Typography>
);

export const StatusCardData = () => (
  <Typography sx={displayFlexColumn}>
    <Typography>
      <Paper />
    </Typography>
    <Typography sx={{ ...poppins400, ...fontsize10 }}>s66w</Typography>
  </Typography>
);

export const ExpCardData = ({ color, value }) => (
  <Typography
    sx={displayFlex}
    style={{
      justifyContent: 'space-around',
    }}
  >
    <Typography sx={displayFlex} style={{ alignItems: 'center' }}>
      <ProfileRed height={20} width={20} color="green" />
    </Typography>
    <Typography>
      <Avatar
        sx={{ bgcolor: 'red', ...poppins400, ...fontsize10 }}
        alt="Remy Sharp"
        style={{
          height: '25px',
          width: '25px',
          color: 'white',
        }}
      >
        {value}
      </Avatar>
    </Typography>
  </Typography>
);

export const ProgressWithCircle = (progress, row) => (
  <Typography sx={displayFlex} style={{ justifyContent: 'center' }}>
    <CircularProgressBar value={progress} row={row} />
  </Typography>
);

export const ActionContainer = ({
  marginLeft,
  setOpenFeedback,
  setFeedBackData,
  rowData,
  setUserName,
  setUserType,
  setBuyerId,
  setUserEmail,
  setUserInitial,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Typography
      sx={[
        displayFlex,
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: marginLeft ? 'flex-start' : 'center',
          gap: 4,
        },
      ]}
    >
      <Button
        sx={{
          width: '80px',
          height: '38px',
          fontSize: '14px',
          fontWeight: 400,
          fontFamily: 'Poppins',
          backgroundColor: 'rgba(108, 42, 210, 0.1)',
          color: '#6C2AD2',
          textTransform: 'capitalize',
        }}
        onClick={() => {
          setUserEmail(rowData?.userEmail);
          setBuyerId(rowData?.user?.userId);
          setOpenFeedback(true);
          setFeedBackData(rowData);
          setUserName(
            `${rowData?.user?.userName} ${rowData?.user?.userSurName}`
          );
          setUserType(rowData?.userCategory[0]?.userType);
          setUserInitial(
            `${rowData?.user?.userName?.trim()?.charAt(0) || ''}${
              rowData?.user?.userSurName?.trim()?.charAt(0) || ''
            }`.toUpperCase()
          );
        }}
      >
        Notes
      </Button>

      <IconButton
        sx={{ border: '1px solid #6C2AD2' }}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {isOpen ? (
          <MoreHorizIcon sx={{ color: '#6C2AD2' }} />
        ) : (
          <MoreVertIcon sx={{ color: '#6C2AD2' }} />
        )}
      </IconButton>
    </Typography>
  );
};

export const ProfileContainer = (progress) => (
  <Typography style={{ justifyContent: 'left' }}>
    <Typography>
      <Button
        variant="outlined"
        size="small"
        sx={{
          fontFamily: 'Poppins',
          fontWeight: '400',
          fontSize: '12px',
          borderRadius: '5px',
          padding: '6px 14px 6px 14px',
          width: '96px',
          height: '30px',
          textTransform: 'none',
          mr: 1,
          color: '#666666',
          border: '1px solid #666666',
        }}
      >
        #Appraisal
      </Button>
    </Typography>
  </Typography>
);

export const TagContainer = (progress) => (
  <Typography style={{ justifyContent: 'left' }}>
    <Typography>
      <Button
        color="error"
        size="small"
        sx={{
          width: '61px',
          height: '34px',
          borderRadius: '20px',
          padding: '8px 20px 8px 20px',
          color: '#F93939',
          fontSize: '12px',
          fontFamily: 'Poppins',
          fontWeight: '400',
          textTransform: 'none',
          border: 'none !important',
          backgroundColor: 'rgba(249, 57, 57, 0.1)',
          mr: 1,
        }}
      >
        Hot
      </Button>
      &nbsp;&nbsp;
      <Button
        color="error"
        variant="outlined"
        size="small"
        sx={{
          width: '110px',
          height: '34px',
          borderRadius: '20px',
          padding: '8px 20px 8px 20px',
          color: '#F93939',
          fontSize: '12px',
          fontFamily: 'Poppins',
          fontWeight: '400',
          textTransform: 'none',
          border: 'none !important',
          backgroundColor: 'rgba(249, 57, 57, 0.1)',
          mr: 1,
        }}
      >
        Conditional
      </Button>
    </Typography>
  </Typography>
);

export const BuyerTagContainer = (progress) => (
  <Typography style={{ justifyContent: 'left' }}>
    <Typography>
      <Button
        variant="outlined"
        color="error"
        size="small"
        sx={{
          ...poppins400,
          ...fontsize12,
          mr: 1,
          borderRadius: 10,
          background: 'rgba(249, 57, 57, 0.1)',
        }}
      >
        Hot
      </Button>
      <Button
        color="error"
        variant="outlined"
        size="small"
        sx={{
          ...poppins400,
          ...fontsize12,
          borderRadius: 10,
          mr: 1,
          background: 'rgba(249, 57, 57, 0.1)',
        }}
      >
        Conditional
      </Button>
    </Typography>
  </Typography>
);
